import SBDropdown from '@Components/Dropdown';
import { Divider, Grid, Paper, Typography } from '@mui/material';
import { vendorAccountType } from '@Reducers/AdminShipment/Type';
import { AppDispatch, RootStateType } from '@Store';
import { useFormik } from 'formik';
import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SBCountryDropdown from '@Components/Dropdown/Country';
import SbButton from '@Components/Button';
import * as Yup from 'yup';
import { PaymentTypeOptions } from '../../ViewSingleShipmentAdmin/components/ShipmentProcessingV2/components/BlueDart/constants';
import { addCarrierSettings, updateCarrierSettings } from '@Reducers/User/actions';
import { setCarrierSettings } from '@Reducers/User';

interface propsTypes {
  onClose: () => void;
  isEditable: boolean;
}

const bluedartInformationSchema = Yup.object().shape({
  countryOfManufacture: Yup.string().trim().required('Country of manufacture is required'),
  subProductCode: Yup.array().required('Sub Product Code is required'),
  accountNo: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('Account value is required'),
        display: Yup.string().required('Account display is required'),
      }),
    )
    .min(1, 'At least one account number is required')
    .required('Account number is required'),
});

const BlueDart = (props: propsTypes) => {
  const { onClose, isEditable } = props;
  const dispatch = useDispatch<AppDispatch>();
  const { vendersAccount } = useSelector((state: RootStateType) => state.adminShipment);
  const { userDataById, carrierSetting } = useSelector((state: RootStateType) => state.user);
  const { values, setFieldValue, errors, handleSubmit } = useFormik<any>({
    enableReinitialize: true,
    validateOnChange: false,
    validationSchema: bluedartInformationSchema,
    initialValues: {
      ...carrierSetting.bluedart,
    },
    onSubmit(values) {
      if (userDataById?._id) {
        if (carrierSetting.bluedart._id) {
          dispatch(updateCarrierSettings({ ...carrierSetting.bluedart, ...values }));
        } else {
          dispatch(addCarrierSettings({ ...carrierSetting.bluedart, ...values }));
        }
        console.info('values', values);
      } else {
        dispatch(setCarrierSettings({ values, carrierType: 'bluedart' }));
      }
      onClose();
    },
  });

  const accountOptions = useMemo(
    () =>
      vendersAccount?.map((item: vendorAccountType) => ({
        value: `${item.accountNo}-${item._id}`,
        display: item.name,
      })),
    [vendersAccount],
  );

  return (
    <div>
      <>
        <Paper
          variant="outlined"
          sx={{
            my: '2rem',
            p: '2rem',
          }}
        >
          <Grid container item xs={12}>
            <Grid container item mb={3}>
              <Grid item xs={12} md={6}>
                <Typography className="font-medium l-text pb-3">BlueDart Information</Typography>{' '}
              </Grid>
            </Grid>
            <Grid container item xs={12} md={12} lg={12} columnSpacing={4} rowSpacing={4}>
              <Grid container item columnSpacing={10} rowSpacing={2}>
                <Grid item xs={12} md={6}>
                  <SBDropdown
                    disabled={!isEditable}
                    id="accountNo"
                    label={`Bluedart Account`}
                    required
                    multiple={true}
                    placeholder="Select"
                    name="accountNo"
                    value={values?.accountNo?.map((item: { value: any }) => item.value)}
                    options={accountOptions}
                    onChange={(_, selectedObj) => {
                      setFieldValue('accountNo', selectedObj);
                    }}
                    error={Array.isArray(errors.accountNo) ? errors.accountNo.join(', ') : (errors.accountNo as string)}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <SBCountryDropdown
                    disabled={!isEditable}
                    required
                    label="Country of Manufacture"
                    value={values?.countryOfManufacture}
                    options={undefined}
                    onChange={value => {
                      setFieldValue('countryOfManufacture', value[0]);
                    }}
                    error={errors?.countryOfManufacture as string}
                  />
                </Grid>
              </Grid>

              <Grid container item columnSpacing={10} rowSpacing={2}>
                <Grid item xs={12} md={6}>
                  <SBDropdown
                    disabled={!isEditable}
                    id="subProductCode"
                    label="Sub Product Code"
                    required
                    multiple={true}
                    placeholder="Select "
                    name="subProductCode"
                    value={values.subProductCode?.map((item: { value: any }) => item)}
                    options={PaymentTypeOptions}
                    onChange={value => {
                      setFieldValue('subProductCode', value);
                    }}
                    error={Array.isArray(errors.accountNo) ? errors.accountNo.join(', ') : (errors.accountNo as string)}
                  />
                </Grid>
              </Grid>
              <Grid container item columnSpacing={10} rowSpacing={2}></Grid>
              <Divider className="mt-3 mb-3" />
              <Grid container item xs={12} md={12} lg={12} columnSpacing={4} rowSpacing={4}>
                <Grid container item sx={{ gap: '1rem' }}>
                  <Grid item xs={12} sm={5} md={2.6} lg={2.7}>
                    <SbButton
                      type="submit"
                      disabled={!isEditable}
                      variant="contained"
                      sx={{ borderRadius: `4px !important` }}
                      className="w-full"
                      onClick={() => {
                        handleSubmit();
                      }}
                    >
                      Save
                    </SbButton>
                  </Grid>
                  {onClose && (
                    <Grid item xs={12} sm={5} md={2.6} lg={2.7}>
                      <SbButton
                        type="button"
                        sx={{ borderRadius: `4px !important` }}
                        className="w-full"
                        variant="outlined"
                        onClick={onClose}
                      >
                        Cancel
                      </SbButton>
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      </>
    </div>
  );
};

export default BlueDart;
